/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * States for Scoped Domain Token (SDT) lifecycle.
 * Tracks the status of DRM token fetch and refresh operations.
 */
export enum SDTState {
  /**
   * SDT successfully fetched and ready for use.
   */
  SUCCESS = "SUCCESS",

  /**
   * SDT fetch is in progress.
   */
  IN_PROGRESS = "IN_PROGRESS",

  /**
   * SDT needs to be refreshed (approaching expiration).
   */
  REFRESH = "REFRESH",

  /**
   * SDT fetch failed.
   */
  ERROR = "ERROR"
}
